// // src/pages/CategoryPerformancePage.jsx
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import styled from "styled-components";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { FaSyncAlt } from "react-icons/fa";
// import { downloadCSV, downloadPDF, printThermal } from "../utils/exportHelpers";
// import ReportShell from "../components/ReportShell";

// const COLOR = {
//   primary: "#015b9a",
//   bg: "#f5f7fb",
//   card: "#ffffff",
//   line: "#e5e7eb",
//   text: "#0f172a",
//   muted: "#6b7280",
// };

// const CategoryPerformancePage = () => {
//   const [userId, setUserId] = useState(null);
//   const [fromDate, setFromDate] = useState(defaultFrom());
//   const [toDate, setToDate] = useState(today());
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);
//   const reportRef = useRef(null);

//   useEffect(() => {
//     const data = JSON.parse(localStorage.getItem("userData") || "{}")?.data;
//     if (!data?.id) {
//       toast.error("User not found. Please login again.");
//       setLoading(false);
//       return;
//     }
//     setUserId(data.id);
//   }, []);

//   useEffect(() => {
//     if (userId) fetchReport();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [userId, fromDate, toDate]);

//   const fetchReport = async (opts = {}) => {
//     if (!userId) return;
//     opts.refresh ? setRefreshing(true) : setLoading(true);
//     try {
//       const res = await fetch(
//         "https://qr.billsarthi.in/public/api/report/category-performance",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             restaurantid: userId,
//             fromdate: fromDate,
//             todate: toDate,
//           }),
//         }
//       );
//       const json = await res.json();
//       if (!res.ok) throw new Error(json?.message || "Failed to load report");
//       const arr = Array.isArray(json?.items) ? json.items : [];
//       const normalized = arr.map((it) => ({
//         name: it.category_name,
//         total_orders: Number(it.total_orders || 0),
//         total_quantity: Number(it.total_quantity || 0),
//         gross_amount: Number(it.gross_amount || 0),
//         avg_order_value: Number(it.avg_order_value || 0),
//         contribution_percent: Number(it.contribution_percent || 0),
//       }));
//       setItems(normalized);
//     } catch (e) {
//       toast.error(e.message || "Unable to load report");
//       setItems([]);
//     } finally {
//       opts.refresh ? setRefreshing(false) : setLoading(false);
//     }
//   };

//   const totals = useMemo(() => {
//     const totalOrders = items.reduce((s, it) => s + it.total_orders, 0);
//     const totalQty = items.reduce((s, it) => s + it.total_quantity, 0);
//     const totalAmt = items.reduce((s, it) => s + it.gross_amount, 0);
//     return { totalOrders, totalQty, totalAmt };
//   }, [items]);

//   const fmtINR = (n) =>
//     `₹${Number(n || 0).toLocaleString("en-IN", {
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0,
//     })}`;

//   const exportCsv = () => {
//     const rows = items.map((it, idx) => [
//       idx + 1,
//       it.name,
//       it.total_orders,
//       it.total_quantity,
//       fmtINR(it.gross_amount),
//       fmtINR(it.avg_order_value),
//       `${Number(it.contribution_percent || 0).toFixed(2)}%`,
//     ]);
//     downloadCSV(
//       `category_performance_${fromDate}_to_${toDate}.csv`,
//       ["#", "Category", "Orders", "Qty", "Gross", "Avg Order", "Contribution %"],
//       rows
//     );
//   };

//   const exportPdf = () =>
//     downloadPDF(reportRef.current, `category_performance_${fromDate}_to_${toDate}.pdf`);

//   return (
//     <ReportShell
//       title="Category Performance"
//       subtitle="See orders, quantity, and revenue per category."
//       bodyRef={reportRef}
//       actions={
//         <Actions>
//           <DateInput>
//             From:
//             <input type="date" value={fromDate} max={toDate} onChange={(e) => setFromDate(e.target.value)} />
//           </DateInput>
//           <DateInput>
//             To:
//             <input type="date" value={toDate} min={fromDate} onChange={(e) => setToDate(e.target.value)} />
//           </DateInput>
//           <PrimaryBtn onClick={() => fetchReport({ refresh: true })}>
//             <FaSyncAlt /> {refreshing ? "Refreshing..." : "Refresh"}
//           </PrimaryBtn>
//         </Actions>
//       }
//     >
//       <ToastContainer position="top-right" autoClose={2200} />
//       <PillRow>
//         <Pill>Orders: {totals.totalOrders}</Pill>
//         <Pill>Qty: {totals.totalQty}</Pill>
//         <Pill>Gross: {fmtINR(totals.totalAmt)}</Pill>
//       </PillRow>

//       <Card>
//         {loading ? (
//           <Center>Loading…</Center>
//         ) : items.length === 0 ? (
//           <Center>No data for this range.</Center>
//         ) : (
//           <TableWrap>
//             <Table>
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Category</th>
//                   <th>Orders</th>
//                   <th>Qty</th>
//                   <th>Gross</th>
//                   <th>Avg Order</th>
//                   <th>Contribution %</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {items.map((it, idx) => (
//                   <tr key={idx}>
//                     <td>{idx + 1}</td>
//                     <td>{it.name}</td>
//                     <td>{it.total_orders}</td>
//                     <td>{it.total_quantity}</td>
//                     <td>{fmtINR(it.gross_amount)}</td>
//                     <td>{fmtINR(it.avg_order_value)}</td>
//                     <td>{`${Number(it.contribution_percent || 0).toFixed(2)}%`}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </TableWrap>
//         )}
//         <Actions style={{ marginTop: 10 }}>
//           <PrimaryBtn onClick={exportPdf}>
//             <FaSyncAlt /> PDF
//           </PrimaryBtn>
//           <PrimaryBtn onClick={exportCsv}>
//             <FaSyncAlt /> CSV
//           </PrimaryBtn>
//         </Actions>
//       </Card>
//     </ReportShell>
//   );
// };

// export default CategoryPerformancePage;

// const today = () => {
//   const d = new Date();
//   const pad = (v) => String(v).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
// };
// const defaultFrom = () => {
//   const d = new Date();
//   d.setDate(d.getDate() - 30);
//   return formatYMD(d);
// };
// const formatYMD = (d) => {
//   const pad = (v) => String(v).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
// };

// /* ---------------- styled ---------------- */
// const PillRow = styled.div`
//   display: flex;
//   gap: 8px;
//   margin-top: 8px;
//   flex-wrap: wrap;
// `;
// const Pill = styled.span`
//   background: #eef2ff;
//   color: ${COLOR.text};
//   padding: 8px 10px;
//   border-radius: 12px;
//   font-weight: 800;
//   border: 1px solid ${COLOR.line};
// `;
// const Actions = styled.div`
//   display: flex;
//   gap: 8px;
//   align-items: center;
//   flex-wrap: wrap;
// `;
// const DateInput = styled.label`
//   display: inline-flex;
//   align-items: center;
//   gap: 6px;
//   padding: 8px 10px;
//   border: 1px solid ${COLOR.line};
//   border-radius: 10px;
//   background: #f9f9f9;
//   color: ${COLOR.text};
//   input {
//     border: 0;
//     background: transparent;
//     outline: none;
//   }
// `;
// const PrimaryBtn = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 6px;
//   padding: 10px 12px;
//   border-radius: 10px;
//   border: none;
//   background: ${COLOR.primary};
//   color: #fff;
//   font-weight: 800;
//   cursor: pointer;
// `;
// const Card = styled.div`
//   background: ${COLOR.card};
//   border: 1px solid ${COLOR.line};
//   border-radius: 16px;
//   padding: 14px;
//   box-shadow: 0 10px 26px rgba(0, 0, 0, 0.05);
// `;
// const TableWrap = styled.div`
//   width: 100%;
//   overflow-x: auto;
//   border: 1px solid ${COLOR.line};
//   border-radius: 12px;
// `;
// const Table = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   thead {
//     background: #eef2ff;
//   }
//   th,
//   td {
//     padding: 10px 12px;
//     border-bottom: 1px solid ${COLOR.line};
//     text-align: left;
//   }
// `;
// const Center = styled.div`
//   text-align: center;
//   color: ${COLOR.muted};
//   padding: 16px;
// `;

// src/pages/CategoryPerformancePage.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaSyncAlt, FaFileInvoice } from "react-icons/fa";
import { downloadCSV, downloadExcel, downloadPDF, printThermal } from "../utils/exportHelpers";
import { formatStoredMoney } from "../utils/currency";
import ReportPeriodPicker from "../components/ReportPeriodPicker";
import ReportPageHeader from "../components/ReportPageHeader";
import ReportControlBar from "../components/ReportControlBar";
import { API_BASE_URL } from "../config/constants";

const COLOR = {
  primary: "#015b9a",
  bg: "#f5f7fb",
  card: "#ffffff",
  line: "#e5e7eb",
  text: "#0f172a",
  muted: "#6b7280",
};

const CategoryPerformancePage = () => {
  const [userId, setUserId] = useState(null);
  const [restaurant, setRestaurant] = useState({});
  const [fromDate, setFromDate] = useState(defaultFrom());
  const [toDate, setToDate] = useState(today());
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const reportRef = useRef(null);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("userData") || "{}")?.data;
    if (!data?.id) {
      toast.error("User not found. Please login again.");
      setLoading(false);
      return;
    }
    setUserId(data.id);
    setRestaurant(data || {});
  }, []);

  useEffect(() => {
    if (userId) fetchReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, fromDate, toDate]);

  const fetchReport = async (opts = {}) => {
    if (!userId) return;
    opts.refresh ? setRefreshing(true) : setLoading(true);
    try {
      const res = await fetch(
        `${API_BASE_URL}/report/category-performance`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            restaurantid: userId,
            fromdate: fromDate,
            todate: toDate,
          }),
        }
      );
      const json = await res.json();
      if (!res.ok) throw new Error(json?.message || "Failed to load report");
      const arr = Array.isArray(json?.items) ? json.items : [];
      const normalized = arr.map((it) => ({
        name: it.category_name,
        total_orders: Number(it.total_orders || 0),
        total_quantity: Number(it.total_quantity || 0),
        gross_amount: Number(it.gross_amount || 0),
        avg_order_value: Number(it.avg_order_value || 0),
        contribution_percent: Number(it.contribution_percent || 0),
      }));
      setItems(normalized);
    } catch (e) {
      toast.error(e.message || "Unable to load report");
      setItems([]);
    } finally {
      opts.refresh ? setRefreshing(false) : setLoading(false);
    }
  };

  const totals = useMemo(() => {
    const totalOrders = items.reduce((s, it) => s + it.total_orders, 0);
    const totalQty = items.reduce((s, it) => s + it.total_quantity, 0);
    const totalAmt = items.reduce((s, it) => s + it.gross_amount, 0);
    return { totalOrders, totalQty, totalAmt };
  }, [items]);

  const fmtINR = (n) => formatStoredMoney(n, { fractionDigits: 0 });

  const exportCsv = () => {
    const rows = items.map((it, idx) => [
      idx + 1,
      it.name,
      it.total_orders,
      it.total_quantity,
      fmtINR(it.gross_amount),
      fmtINR(it.avg_order_value),
      `${Number(it.contribution_percent || 0).toFixed(2)}%`,
    ]);
    downloadCSV(
      `category_performance_${fromDate}_to_${toDate}.csv`,
      [
        "#",
        "Category",
        "Orders",
        "Qty",
        "Gross",
        "Avg Order",
        "Contribution %",
      ],
      rows
    );
  };

  const exportExcel = () => {
    const rows = items.map((it, idx) => [
      idx + 1,
      it.name,
      it.total_orders,
      it.total_quantity,
      fmtINR(it.gross_amount),
      fmtINR(it.avg_order_value),
      `${Number(it.contribution_percent || 0).toFixed(2)}%`,
    ]);
    downloadExcel(
      `category_performance_${fromDate}_to_${toDate}.xlsx`,
      [
        "#",
        "Category",
        "Orders",
        "Qty",
        "Gross",
        "Avg Order",
        "Contribution %",
      ],
      rows
    );
  };

  const exportPdf = () =>
    downloadPDF(
      reportRef.current,
      `category_performance_${fromDate}_to_${toDate}.pdf`
    );

  // Restaurant info for PDF header
  const restaurantName =
    restaurant.restaurant_name ||
    restaurant.restaurantname ||
    restaurant.name ||
    "Restaurant";

  const restaurantAddress =
    restaurant.addressline3 ||
    restaurant.address ||
    restaurant.restaurantaddress ||
    restaurant.city ||
    "";

  const restaurantPhone =
    restaurant.mobile_number ||
    restaurant.mobile ||
    restaurant.phone ||
    restaurant.contactnumber ||
    "";

  const generatedOn = useMemo(
    () =>
      new Date().toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    []
  );

  return (
    <Page>
      <ToastContainer position="top-right" autoClose={2200} />

      <ReportPageHeader
        title="Category Performance"
        subtitle="See orders, quantity, and revenue per category for the selected period."
        stats={[
          { label: "Total Categories", value: items.length },
          { label: "Total Orders", value: totals.totalOrders },
          { label: "Total Qty", value: totals.totalQty },
          { label: "Total Gross", value: fmtINR(totals.totalAmt) },
        ]}
      />

      <ReportControlBar>
        <ReportPeriodPicker fromDate={fromDate} toDate={toDate} onChange={({ from, to }) => { setFromDate(from); setToDate(to); }} />
        <PrimaryBtn onClick={() => fetchReport({ refresh: true })}>
          <FaSyncAlt /> {refreshing ? "Refreshing..." : "Refresh"}
        </PrimaryBtn>
      </ReportControlBar>

      <Card>
        {/* ✅ Only this part goes to PDF */}
        <div ref={reportRef}>
          {/* PDF Header */}
          <PdfHeaderCard>
            <PdfHeaderRow>
              <div className="left">
                <div className="resto">{restaurantName}</div>
                {restaurantAddress && (
                  <div className="line">{restaurantAddress}</div>
                )}
                {restaurantPhone && (
                  <div className="line">Phone: {restaurantPhone}</div>
                )}
              </div>
              <div className="right">
                <HeaderTitleRow>
                  <FaFileInvoice />
                  <h2>Category Performance Report</h2>
                </HeaderTitleRow>
                <div className="line">
                  Period: <strong>{fromDate}</strong> to{" "}
                  <strong>{toDate}</strong>
                </div>
                <div className="line">
                  Generated on: <strong>{generatedOn}</strong>
                </div>
              </div>
            </PdfHeaderRow>
          </PdfHeaderCard>

          {loading ? (
            <Center>Loading…</Center>
          ) : items.length === 0 ? (
            <Center>No data for this range.</Center>
          ) : (
            <TableWrap>
              <Table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Category</th>
                    <th>Orders</th>
                    <th>Qty</th>
                    <th>Gross</th>
                    <th>Avg Order</th>
                    <th>Contribution %</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((it, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{it.name}</td>
                      <td>{it.total_orders}</td>
                      <td>{it.total_quantity}</td>
                      <td>{fmtINR(it.gross_amount)}</td>
                      <td>{fmtINR(it.avg_order_value)}</td>
                      <td>{`${Number(it.contribution_percent || 0).toFixed(
                        2
                      )}%`}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </TableWrap>
          )}

          {/* PDF Footer */}
          <PdfFooter>
            <span>Powered by</span>
            <strong>BillSarthi</strong>
          </PdfFooter>
        </div>

        {/* ✅ Buttons outside PDF content */}
        <Actions style={{ marginTop: 10 }}>
          <PrimaryBtn onClick={exportExcel}>
            Excel
          </PrimaryBtn>
          <PrimaryBtn onClick={exportPdf}>
            <FaSyncAlt /> PDF
          </PrimaryBtn>
          <PrimaryBtn
            onClick={() =>
              printThermal(reportRef.current, `category_performance_${fromDate}_to_${toDate}`)
            }
          >
            Thermal Print
          </PrimaryBtn>
          <PrimaryBtn onClick={exportCsv}>
            <FaSyncAlt /> CSV
          </PrimaryBtn>
        </Actions>
      </Card>
    </Page>
  );
};

export default CategoryPerformancePage;

const today = () => {
  const d = new Date();
  const pad = (v) => String(v).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
const defaultFrom = () => {
  const d = new Date();
  d.setDate(d.getDate() - 30);
  return formatYMD(d);
};
const formatYMD = (d) => {
  const pad = (v) => String(v).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/* ---------------- styled ---------------- */
const Page = styled.div`
  background: ${COLOR.bg};
  min-height: 100vh;
  padding: 16px;
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 1.2rem;
  font-weight: 900;
  color: ${COLOR.text};
`;

const Sub = styled.div`
  color: ${COLOR.muted};
`;

const PillRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
`;

const Pill = styled.span`
  background: #eef2ff;
  color: ${COLOR.text};
  padding: 8px 10px;
  border-radius: 12px;
  font-weight: 800;
  border: 1px solid ${COLOR.line};
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

const DateInput = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid ${COLOR.line};
  border-radius: 10px;
  background: #f9f9f9;
  color: ${COLOR.text};
  input {
    border: 0;
    background: transparent;
    outline: none;
  }
`;

const PrimaryBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  border-radius: 10px;
  border: none;
  background: ${COLOR.primary};
  color: #fff;
  font-weight: 800;
  cursor: pointer;
`;

const Card = styled.div`
  background: ${COLOR.card};
  border: 1px solid ${COLOR.line};
  border-radius: 16px;
  padding: 14px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.05);
`;

const TableWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 1px solid ${COLOR.line};
  border-radius: 12px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  thead {
    background: #eef2ff;
  }
  th,
  td {
    padding: 10px 12px;
    border-bottom: 1px solid ${COLOR.line};
    text-align: left;
  }
`;

const Center = styled.div`
  text-align: center;
  color: ${COLOR.muted};
  padding: 16px;
`;

/* ==== PDF Header / Footer ==== */
const PdfHeaderCard = styled.div`
  border-radius: 14px;
  border: 1px solid ${COLOR.line};
  padding: 10px 12px;
  margin-bottom: 12px;
  background: linear-gradient(90deg, #ffffff, #f5fbff);
`;

const PdfHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  .left {
    min-width: 180px;
  }
  .resto {
    font-size: 1.05rem;
    font-weight: 800;
    color: ${COLOR.primary};
    margin-bottom: 4px;
  }
  .line {
    color: ${COLOR.muted};
    font-size: 0.82rem;
  }
  .right {
    text-align: right;
  }
  @media (max-width: 720px) {
    flex-direction: column;
    .left {
      min-width: 0;
    }
    .right {
      text-align: left;
    }
  }
`;

const HeaderTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 4px;
  h2 {
    margin: 0;
    font-size: 1rem;
    font-weight: 800;
  }
`;

const PdfFooter = styled.div`
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px dashed ${COLOR.line};
  text-align: center;
  font-size: 11px;
  color: ${COLOR.muted};
  strong {
    color: ${COLOR.primary};
    margin-left: 4px;
  }
`;
